import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoIconLarge]',
  host: { class: 'xpo-Icon--large' }
})
export class XpoIconLarge { }
